import { useState } from "react";
import { useAsync } from "react-async";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import { getDistrictsCount } from "../../../../api/services/districtService";
import { Link, useHistory } from "react-router-dom";
import Spinner from "../../../spinner";
import { getDisciplinesWithTherapistCount } from "../../../../api/services/therapistService";
import DisciplinesWithTherapistCountModel from "../../../../api/models/disciplinesWithTherapistCountModel";

const DashboardWidgetBillingSpecialistGeneral = ({ user }: DashboardProps): JSX.Element => {
    const [districtsCount, setDistrictsCount] = useState<number>(0);
    const [disciplineTherapists, setDisciplineTherapists] = useState<DisciplinesWithTherapistCountModel[]>();
    const [totalActiveTherapists, setTotalActiveTherapists] = useState<number>(0);
    const history = useHistory();

    const asyncDistrictsCount = useAsync({
        promiseFn: getDistrictsCount,
        onResolve: (r) => setDistrictsCount(r.data)
    });

    const asyncDisciplineTherapists = useAsync({
        promiseFn: getDisciplinesWithTherapistCount,
        onResolve: (r) => {
            setDisciplineTherapists(r.data);
            let totalActive = 0;
            r.data.map(x => totalActive += x.therapistCount ?? 0);
            setTotalActiveTherapists(totalActive);
        }
    });

    return (
        <div className={`${DashboardPropsDefaults.containerClassNames}`}>
            <div className="pb-1 dashboard-widget-title">
                <h3>General Information</h3>
            </div>
            <div className={`${DashboardPropsDefaults.contentClassNames}`}>
                <Spinner show={(asyncDistrictsCount.isPending || asyncDisciplineTherapists.isPending)} />
                {!(asyncDistrictsCount.isPending || asyncDisciplineTherapists.isPending) && <>
                    <div>
                        {districtsCount && districtsCount > 0 && (
                            <div className={`mb-2 font-bold`}>All Active Districts: <Link className={`font-normal`} to={`/admin/districts`}>({districtsCount})</Link></div>
                        )}
                    </div>
                    <div>
                        {totalActiveTherapists > 0 && (<>
                            <div className={`mb-2 font-bold`}>Total Active Therapists: <Link className={`font-normal`} to={`/admin/therapists`}>({totalActiveTherapists})</Link></div>
                        </>)}
                    </div>
                    <div className={`mb-2 mt-2`}>
                        <h3 className="mb-1 text-sm font-bold">Disciplines:</h3>
                        {disciplineTherapists?.map((discipline: DisciplinesWithTherapistCountModel, i: number) =>
                            <div key={`du-${discipline.disciplineId}`}>
                                <h3 className="mb-1 text-xs">
                                    {discipline.disciplineName}&nbsp;
                                    (<span className="underline cursor-pointer hover:no-underline"
                                        onClick={() => history.push('/admin/therapists', { disciplineId: discipline.disciplineId }
                                        )}>{discipline.therapistCount}</span>)
                                </h3>
                            </div>
                        )}
                    </div>
                </>}
            </div>
        </div>
    );
};

export default DashboardWidgetBillingSpecialistGeneral;
